import { ParsedUrlQuery } from 'querystring';
import { Company } from '@streamfields/BonusweltSlider/models';
import { getRequest } from '../../api/wagtail';

async function sendGetRequest(id: string, params: ParsedUrlQuery) {
  return (await getRequest<Company>(`bonuswelt/${id}/`, params)).json;
}

function get_company(id: string) {
  return sendGetRequest(id.toString(), {});
}

export { get_company };
